<template>
  <div
    class="w-full mx-auto gap-8 px-6 md:px-8 lg:px-10 xl:px-16 max-w-screen-xl flex flex-col md:flex-row items-center justify-center"
    :class="{ 'md:flex-row-reverse': !imageLeft }"
  >
    <div class="flex flex-1">
      <img :src="imageSrc" :alt="imageAlt" class="max-w-full h-auto" />
    </div>

    <div class="flex flex-1">
      <div
        class="flex flex-col items-center md:items-start gap-5 text-center md:text-left w-full"
      >
        <div class="w-full h-full flex gap-10 flex-col">
          <div>
            <div class="text-2xl font-bold text-gray-900" v-html="title"></div>
            <div
              v-if="subtitle && subtitle.trim()"
              class="text-lg text-gray-700"
              v-html="subtitle"
            ></div>
          </div>
          <ul class="grid grid-cols-1 gap-x-8 gap-y-5 box p-10">
            <li
              v-for="(item, index) in items"
              :key="`package-${index}`"
              class="flex gap-5"
            >
              <font-awesome-icon
                :icon="['far', 'check-circle']"
                class="w-6 h-6 mt-1 text-primary-color"
              />
              <span>{{ item }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    subtitle: String,
    packages: {
      type: String,
      default: "",
    },
    imageSrc: String,
    imageAlt: String,
    imageLeft: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    items() {
      if (!this.packages || this.packages.trim() === "") {
        return [];
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(this.packages, "text/html");
      return Array.from(doc.querySelectorAll("li")).map((li) => li.textContent);
    },
  },
};
</script>
